/*!
 * froala_editor v2.6.2 (https://www.froala.com/wysiwyg-editor)
 * License https://froala.com/wysiwyg-editor/terms/
 * Copyright 2014-2017 Froala Labs
 */

(function (factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define(['jquery'], factory);
    } else if (typeof module === 'object' && module.exports) {
        // Node/CommonJS
        module.exports = function( root, jQuery ) {
            if ( jQuery === undefined ) {
                // require('jQuery') returns a factory that requires window to
                // build a jQuery instance, we normalize how we use modules
                // that require this pattern but the window provided is a noop
                // if it's defined (how jquery works)
                if ( typeof window !== 'undefined' ) {
                    jQuery = require('jquery');
                }
                else {
                    jQuery = require('jquery')(root);
                }
            }
            return factory(jQuery);
        };
    } else {
        // Browser globals
        factory(window.jQuery);
    }
}(function ($) {
/**
 * German
 */

$.FE.LANGUAGE['de'] = {
  translation: {
    // Place holder
    "Type something": "Schreiben Sie etwas",

    // Basic formatting
    "Bold": "Fett",
    "Italic": "Kursiv",
    "Underline": "Unterstrichen",
    "Strikethrough": "Durchgestrichen",

    // Main buttons
    "Insert": "Einf\u00fcgen",
    "Delete": "L\u00f6schen",
    "Cancel": "Abbrechen",
    "OK": "Ok",
    "Back": "Zur\u00fcck",
    "Remove": "Entfernen",
    "More": "Mehr",
    "Update": "Aktualisierung",
    "Style": "Stil",

    // Font
    "Font Family": "Schriftart",
    "Font Size": "Schriftgr\u00f6\u00dfe",

    // Colors
    "Colors": "Farben",
    "Background": "Hintergrund",
    "Text": "Text",

    // Paragraphs
    "Paragraph Format": "Formate",
    "Normal": "Normal",
    "Code": "Quelltext",
    "Heading 1": "\u00dcberschrift 1",
    "Heading 2": "\u00dcberschrift 2",
    "Heading 3": "\u00dcberschrift 3",
    "Heading 4": "\u00dcberschrift 4",

    // Style
    "Paragraph Style": "Absatz-Stil",
    "Inline Style": "Inline-Stil",

    // Alignment
    "Align": "Ausrichtung",
    "Align Left": "Linksb\u00fcndig ausrichten",
    "Align Center": "Zentriert ausrichten",
    "Align Right": "Rechtsb\u00fcndig ausrichten",
    "Align Justify": "Blocksatz",
    "None": "Keine",

    // Lists
    "Ordered List": "Geordnete Liste",
    "Unordered List": "Ungeordnete Liste",

    // Indent
    "Decrease Indent": "Einzug verkleinern",
    "Increase Indent": "Einzug vergr\u00f6\u00dfern",

    // Links
    "Insert Link": "Link einf\u00fcgen",
    "Open in new tab": "In neuem Tab \u00f6ffnen",
    "Open Link": "Link \u00d6ffnen",
    "Edit Link": "Link bearbeiten",
    "Unlink": "Link entfernen",
    "Choose Link": "Einen Link ausw\u00e4hlen",

    // Images
    "Insert Image": "Bild einf\u00fcgen",
    "Upload Image": "Bild hochladen",
    "By URL": "Von URL",
    "Browse": "Ordner",
    "Drop image": "Ziehen Sie ein Bild hierher",
    "or click": "oder klicken Sie hier",
    "Manage Images": "Bilder verwalten",
    "Loading": "Laden",
    "Deleting": "L\u00f6schen",
    "Tags": "Tags",
    "Are you sure? Image will be deleted.": "Sind Sie sicher? Das Bild wird gel\u00f6scht.",
    "Replace": "Ersetzen",
    "Uploading": "Hochladen",
    "Loading image": "Das Bild wird geladen",
    "Display": "Textausrichtung",
    "Inline": "Mit Text in einer Zeile",
    "Break Text": "Text umbrechen",
    "Alternate Text": "Alternativtext",
    "Change Size": "Gr\u00f6\u00dfe \u00e4ndern",
    "Width": "Breite",
    "Height": "H\u00f6he",
    "Something went wrong. Please try again.": "Etwas ist schief gelaufen. Bitte versuchen Sie es erneut.",

    // Video
    "Insert Video": "Video einf\u00fcgen",
    "Embedded Code": "Eingebetteter Code",

    // Tables
    "Insert Table": "Tabelle einf\u00fcgen",
    "Table Header": "Tabellenkopf",
    "Remove Table": "Tabelle entfernen",
    "Table Style": "Tabelle Stil",
    "Horizontal Align": "Horizontal Ausrichtung",
    "Row": "Zeile",
    "Insert row above": "Neue Zeile davor einf\u00fcgen",
    "Insert row below": "Neue Zeile danach einf\u00fcgen",
    "Delete row": "Zeile l\u00f6schen",
    "Column": "Spalte",
    "Insert column before": "Neue Spalte davor einf\u00fcgen",
    "Insert column after": "Neue Spalte danach einf\u00fcgen",
    "Delete column": "Spalte l\u00f6schen",
    "Cell": "Zelle",
    "Merge cells": "Zelle verschmelzen",
    "Horizontal split": "Horizontal teilen",
    "Vertical split": "Vertikal teilen",
    "Cell Background": "Zellenhintergrund",
    "Vertical Align": "Vertikale Ausrichtung",
    "Top": "Oben",
    "Middle": "Zentriert",
    "Bottom": "Unten",
    "Align Top": "Oben ausrichten",
    "Align Middle": "Zentriert ausrichten",
    "Align Bottom": "Unten ausrichten",
    "Cell Style": "Zellen-Stil",

    // Files
    "Upload File": "Datei Hochladen",
    "Drop file": "Ziehen Sie eine Datei hierhin",

    // Emoticons
    "Emoticons": "Emoticons",
    "Grinning face": "Grinsendes Gesicht",
    "Grinning face with smiling eyes": "Grinsend Gesicht mit l\u00e4chelnden Augen",
    "Face with tears of joy": "Gesicht mit Tr\u00e4nen der Freude",
    "Smiling face with open mouth": "L\u00e4chelndes Gesicht mit offenem Mund",
    "Smiling face with open mouth and smiling eyes": "L\u00e4chelndes Gesicht mit offenem Mund und l\u00e4chelnden Augen",
    "Smiling face with open mouth and cold sweat": "L\u00e4chelndes Gesicht mit offenem Mund und kaltem Schwei\u00df",
    "Smiling face with open mouth and tightly-closed eyes": "L\u00e4chelndes Gesicht mit offenem Mund und fest geschlossenen Augen",
    "Smiling face with halo": "L\u00e4cheln Gesicht mit Heiligenschein",
    "Smiling face with horns": "L\u00e4cheln Gesicht mit H\u00f6rnern",
    "Winking face": "Zwinkerndes Gesicht",
    "Smiling face with smiling eyes": "L\u00e4chelndes Gesicht mit l\u00e4chelnden Augen",
    "Face savoring delicious food": "Gesicht leckeres Essen genie\u00dfend",
    "Relieved face": "Erleichtertes Gesicht",
    "Smiling face with heart-shaped eyes": "L\u00e4chelndes Gesicht mit herzf\u00f6rmigen Augen",
    "Smiling face with sunglasses": "L\u00e4chelndes Gesicht mit Sonnenbrille",
    "Smirking face": "Grinsendes Gesicht",
    "Neutral face": "Neutrales Gesicht",
    "Expressionless face": "Ausdrucksloses Gesicht",
    "Unamused face": "Genervtes Gesicht",
    "Face with cold sweat": "Gesicht mit kaltem Schwei\u00df",
    "Pensive face": "Nachdenkliches Gesicht",
    "Confused face": "Verwirrtes Gesicht",
    "Confounded face": "Elendes Gesicht",
    "Kissing face": "K\u00fcssendes Gesicht",
    "Face throwing a kiss": "Gesicht wirft einen Kuss",
    "Kissing face with smiling eyes": "K\u00fcssendes Gesicht mit l\u00e4chelnden Augen",
    "Kissing face with closed eyes": "K\u00fcssendes Gesicht mit geschlossenen Augen",
    "Face with stuck out tongue": "Gesicht mit herausgestreckter Zunge",
    "Face with stuck out tongue and winking eye": "Gesicht mit herausgestreckter Zunge und zwinkerndem Auge",
    "Face with stuck out tongue and tightly-closed eyes": "Gesicht mit herausgestreckter Zunge und fest geschlossenen Augen",
    "Disappointed face": "Entt\u00e4uschtes Gesicht",
    "Worried face": "Besorgtes Gesicht",
    "Angry face": "Ver\u00e4rgertes Gesicht",
    "Pouting face": "Schmollendes Gesicht",
    "Crying face": "Weinendes Gesicht",
    "Persevering face": "Ausharrendes Gesicht",
    "Face with look of triumph": "Gesicht mit triumphierenden Blick",
    "Disappointed but relieved face": "Entt\u00e4uschtes, aber erleichtertes Gesicht",
    "Frowning face with open mouth": "Entsetztes Gesicht mit offenem Mund",
    "Anguished face": "Gequ\u00e4ltes Gesicht",
    "Fearful face": "Angstvolles Gesicht",
    "Weary face": "M\u00fcdes Gesicht",
    "Sleepy face": "Schl\u00e4friges Gesicht",
    "Tired face": "G\u00e4hnendes Gesicht",
    "Grimacing face": "Grimassenschneidendes Gesicht",
    "Loudly crying face": "Laut weinendes Gesicht",
    "Face with open mouth": "Gesicht mit offenem Mund",
    "Hushed face": "Besorgtes Gesicht mit offenem Mund",
    "Face with open mouth and cold sweat": "Gesicht mit offenem Mund und kaltem Schwei\u00df",
    "Face screaming in fear": "Vor Angst schreiendes Gesicht",
    "Astonished face": "Erstauntes Gesicht",
    "Flushed face": "Ger\u00f6tetes Gesicht",
    "Sleeping face": "Schlafendes Gesicht",
    "Dizzy face": "Schwindliges Gesicht",
    "Face without mouth": "Gesicht ohne Mund",
    "Face with medical mask": "Gesicht mit Mundschutz",

    // Line breaker
    "Break": "Zeilenumbruch",

    // Math
    "Subscript": "Tiefgestellt",
    "Superscript": "Hochgestellt",

    // Full screen
    "Fullscreen": "Vollbild",

    // Horizontal line
    "Insert Horizontal Line": "Horizontale Linie einf\u00fcgen",

    // Clear formatting
    "Clear Formatting": "Formatierung l\u00f6schen",

    // Undo, redo
    "Undo": "R\u00fcckg\u00e4ngig",
    "Redo": "Wiederholen",

    // Select all
    "Select All": "Alles ausw\u00e4hlen",

    // Code view
    "Code View": "Code-Ansicht",

    // Quote
    "Quote": "Zitieren",
    "Increase": "Vergr\u00f6\u00dfern",
    "Decrease": "Verkleinern",

    // Quick Insert
    "Quick Insert": "Schnelleinsatz"
  },
  direction: "ltr"
};

}));
